<template>
  <router-view/>
</template>

<script setup>
import { onMounted, onUnmounted } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
import { AUTH_SESSION_EXPIRED_EVENT, PASSWORD_CHANGE_EVENT, PASSWORD_CHANGE_PATH } from '@/util/passwordSecurity';

const store = useStore();
const router = useRouter();
const requirePasswordChange = (event) => {
  if (!localStorage.getItem('accessToken')) return;
  store.commit('requirePasswordChange', event.detail);
  if (router.currentRoute.value.path !== PASSWORD_CHANGE_PATH) {
    router.replace(PASSWORD_CHANGE_PATH);
  }
};
window.addEventListener(PASSWORD_CHANGE_EVENT, requirePasswordChange);
const handleSessionExpired = async () => {
  await store.dispatch('logout');
  if (router.currentRoute.value.path !== '/login') await router.replace('/login');
  ElMessage.warning('账号已在其他位置登录或登录状态已失效，请重新登录');
};
const checkSession = () => {
  if (localStorage.getItem('accessToken') && router.currentRoute.value.path !== '/login') {
    store.dispatch('fetchUserInfo');
  }
};
const checkVisibleSession = () => {
  if (document.visibilityState === 'visible') checkSession();
};
const handleTokenReplaced = (event) => {
  if (event.key !== 'accessToken' || !event.newValue || event.newValue === event.oldValue) return;
  if (router.currentRoute.value.path !== '/login') handleSessionExpired();
};
let sessionTimer;
window.addEventListener(AUTH_SESSION_EXPIRED_EVENT, handleSessionExpired);
window.addEventListener('focus', checkSession);
document.addEventListener('visibilitychange', checkVisibleSession);
window.addEventListener('storage', handleTokenReplaced);

onUnmounted(() => {
  window.removeEventListener(PASSWORD_CHANGE_EVENT, requirePasswordChange);
  window.removeEventListener(AUTH_SESSION_EXPIRED_EVENT, handleSessionExpired);
  window.removeEventListener('focus', checkSession);
  document.removeEventListener('visibilitychange', checkVisibleSession);
  window.removeEventListener('storage', handleTokenReplaced);
  clearInterval(sessionTimer);
});

onMounted(() => {
  if (!store.getters.userInfo && localStorage.getItem('accessToken')) {
    store.dispatch('fetchUserInfo');
  }
  sessionTimer = setInterval(checkSession, 10000);
});
</script>
<style lang="scss">
@import './assets/style/common.scss';
:root {
  --el-color-primary: #0C7AE1;
  --el-color-primary-light-3: #3aa1e8;
  --el-color-primary-light-5: #5fb3ed;
  --el-color-primary-light-7: #87c6f2;
  --el-color-primary-light-8: #9ad0f4;
  --el-color-primary-light-9: #d6e8fa;
  --el-color-primary-dark-2: #0961b3;
}
#app .el-pager{
  gap: 10px;
  margin-left: 10px;
  margin-right: 10px;
}
.policy-content img:not([src*="icon_doc"]){
  width: 100%;
}

* {
  margin: 0px;
  padding: 0px;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
}

a {
  text-decoration: none;
}

body {
  width: 100%;
  background-repeat: no-repeat;
  background-size: cover;
}
#app {
  font-family: MiSans VF, MiSans VF;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  display: flex;
  flex-direction: column;
  color: $font-color;
}
.breadcrumb {
  padding: 13px 120px;
  border-top: 1px solid #E6E8ED;
  border-bottom: 1px solid #E6E8ED;

  :deep(.el-breadcrumb) {
    font-size: 14px;

    a {
      color: #666;

      &:hover {
        color: #1890FF;
      }
    }

    .el-breadcrumb__item:last-child .el-breadcrumb__inner {
      color: #333;
      font-weight: 500;
    }
  }
}
.box-shadow:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease-in-out;
    transform: translateY(-2px);
}
.table_header_column {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 16px;
  padding-bottom: 16px;
  .left_view {
    display: flex;
    align-items: center;
    gap: 16px;
  }
  .right_view {
    display: flex;
    align-items: center;
    gap: 12px;
  }
  .el-form-item {
    margin: 0;
  }
  .el-form-item__content {
    gap: 12px;
  }
  .el-form-item__label {
    font-weight: 500;
    font-size: 14px;
    color: #666666;
    display: flex;
    align-items: center;
    height: auto;
    line-height: normal;
    padding: 0;
  }
  .el-button + .el-button {
    margin-left: 0;
  }
}
.table_pagination {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    margin: 12px 0;
    .total {
        font-size: 14px;
        color: #8D9094;
        span {
            color: #5F49E5;
            color: #0C7AE1;
        }
    }

    .pagination,
    :deep(.el-select__wrapper),
    :deep(.el-pager li),
    :deep(.el-input__inner) {
        font-size: 14px;
    }

    :deep(.el-select__wrapper) {
        min-height: 24px;
        line-height: 24px;
        padding: 4px 12px;
    }

    :deep(.el-input__inner) {
        height: 24px;
        line-height: 24px;
    }

    :deep(.el-pagination.is-background .btn-next),
    :deep(.el-pagination.is-background .btn-prev),
    :deep(.el-pagination.is-background .el-pager li) {
        background-color: white;
        border: 1px solid #CED4DB;
        min-width: 24px;
        height: 24px;
        box-sizing: border-box;
    }

    :deep(.el-pagination.is-background .btn-next.is-active),
    :deep(.el-pagination.is-background .btn-prev.is-active),
    :deep(.el-pagination.is-background .el-pager li.is-active) {
        background-color: #4389F9;
    }
}
.el-tooltip{
  max-width: 500px;
}
.el-dialog__body{
    max-height: 72vh;
    overflow-y: auto;
}
.active-tag{
    background: rgba(12, 122, 225, 0.2);
    border: 1px solid #0C7AE1;
    color: #0C7AE1;
}
</style>
